/**
 * 简单的国际化工具
 * 支持中文和英文切换
 */

// 翻译文本
const translations = {
  zh: {
    // ========== 封面页 ==========
    platformTitle: '让可视化',
    platformSubtitle: '轻松实现',
    platformSuffix: '',
    thinkIt: '浩瀚启蒙',
    connector: '，',
    getIt: '所想即视',
    thinkGetEn: 'THINK IT, GET IT',
    logoChinese: '瀚蒙视',
    startExperience: '开始体验',
    scrollDownToExplore: '向下滑动探索更多',
    poweredBy: 'Powered by Advanced AI Technology',
    whatCanIDo: '我能做什么？',
    realScenariosTitle: '真实应用场景',
    realScenariosSub: '讲座 · 论文 · 赛课 · 课题 · 微课',

    // Feature cards
    mathAnimation: '数学动画',
    interactive3D: '3D交互',
    geometry: '几何绘图',
    smartSolve: '智能解题',

    // Language options
    language: '语言',
    chinese: '中文',
    english: 'English',
    
    // ========== 主页面 ==========
    // 页头
    navigation: '导航',
    showcaseGallery: '展示平台',
    newUserGuide: '新手引导',
    logoTitle: 'HAMMERATH',
    welcomeUser: '见你想见！',
    guest: '游客',
    welcomeUserSeparator: '，',
    tagline: '浩瀚启蒙，所想即视',
    taglineEn: 'Think it, Get it',
    remainingCredits: '剩余积分',
    getMoreCredits: '更多积分',
    purchasedCredits: '充值积分',
    bonusCreditsLabel: '赠送积分',
    expireAtMonthEnd: '月末清零',
    
    // 加载状态
    analyzing: '正在分析题目...',
    understanding: '理解题目要求...',
    building: '构建解题思路...',
    deriving: '逐步推导过程...',
    verifying: '验证解答步骤...',
    organizing: '整理解题过程...',
    parsing: '正在解析您的需求...',
    constructing: '构建数学模型...',
    generating: '生成初始代码框架...',
    filling: '填充核心逻辑...',
    optimizing: '优化代码结构...',
    completing: '即将完成，请稍候...',

    // 推荐作品相关文案
    recommendedInspirations: '灵感与相关作品推荐',
    recommendedWhileWaiting: '等待生成时，不妨浏览这些类似作品',
    personalizedRecommendations: '已结合你的近期创作偏好与当前主题',
    previewWork: '预览作品',
    previewWorkDesc: '点击查看作品详情与效果',
    generatingInProgress: '正在为您生成',
    generationCompleteNotice: '您的作品已生成完成！',
    viewGenerationResult: '立即查看结果',
    openInNewTab: '新标签页打开',
    noSimilarShowcase: '暂无高度相似作品，已为您推荐同品类精选',
    indexedKeywords: '已索引关键词',
    matchedKeywordsPrefix: '已根据关键词',
    matchedKeywordsSuffix: '为您精准推荐相关作品',

    // 各种模式的加载文案
    loadingProgress: '进度',
    manimLoadingTexts: [
      "正在解析您的需求...",
      "构建数学模型...",
      "生成初始代码框架...",
      "填充核心逻辑...",
      "优化代码结构...",
      "即将完成，请稍候..."
    ],
    solveLoadingTexts: [
      "正在分析题目...",
      "理解题目要求...",
      "构建解题思路...",
      "逐步推导过程...",
      "验证解答步骤...",
      "整理解题过程..."
    ],
    solveVideoLoadingTexts: [
      "正在生成视频讲解...",
      "绘制几何图形...",
      "添加动画效果...",
      "合成语音解说...",
      "渲染视频帧...",
      "即将完成..."
    ],
    threejsLoadingTexts: [
      "正在解析您的需求...",
      "构建3D交互模型...",
      "生成HTML结构...",
      "配置交互控件...",
      "优化渲染性能...",
      "即将完成，请稍候..."
    ],
    geogebraLoadingTexts: [
      "正在解析几何需求...",
      "分析图形结构...",
      "生成GeoGebra指令...",
      "优化绘图顺序...",
      "配置图形样式...",
      "即将完成，请稍候..."
    ],
    qqLoadingTexts: [
      "正在分析问题结构...",
      "识别问题核心要素...",
      "拆解问题链条...",
      "构建逻辑关系...",
      "生成可视化界面...",
      "优化交互体验...",
      "即将完成，请稍候..."
    ],
    
    // 按钮和操作
    return: '返回',
    autoSavedToRepoPrefix: '该作品已自动存入您的',
    autoSavedToRepoSuffix: '中，供您随时下载',
    repository: '仓库',
    refineIt: '还不满意？微调试试',
    preview: '动画预览',
    viewEffect: '查看3D演示效果',
    videoExplanation: '视频讲解',
    generating: '正在生成...',
    fixCode: '一键修复',
    fixing: '正在修复...',
    noImageFix: '没出图像？一键修复',
    
    // 错误和提示
    renderError: '渲染出错',
    pleaseInputDescription: '请输入您的描述',
    insufficientCredits: '积分不足，请关注社群获取积分',
    loadingProgress: '进度',
    // Modes & Prompts
    welcomeAI4GGB: '欢迎使用AI4GGB！请描述您想要绘制的几何图形或数学函数，AI将为您生成GeoGebra指令。',
    welcomeSolve: '欢迎使用锤锤解题！请输入您的数学题目或上传题目图片，AI将为您提供详细的解题分析。',
    welcome3D: '欢迎使用3D模式！请描述您想要绘制的几何图形或数学函数...',
    welcomeQQ: '欢迎使用QQ模式！请描述您需要分析拆解的问题...',
    generationComplete: '生成完成！',
    qqAnalysisComplete: '问题拆解完成！点击下方按钮可反复查看',
    view3DEnabled: '3D视图已开启',
    view3DDisabled: '3D视图',
    animationPreview: '动画预览',
    refineIt: '还不满意？微调试试',
    autoSavedToRepoPrefix: '温馨提示：该作品已自动存入您的',
    autoSavedToRepoSuffix: '中',
    repository: '仓库',
    needVoiceover: '是否需要语音旁白？',
    baseCost: '基础消耗',
    extraAudioCost: '+音频额外',
    yesLabel: '是',
    noLabel: '否',
    cancelGenerate: '取消生成',
    
    // 模式选择
    hoverForMore: '悬停查看更多模式',
    costLabel: '消耗',
    limitedTime: '限时',
    creditsPerUse: '积分/次',
    
    // 输入提示
    inputPlaceholder: '你想看见什么动画？',
    manimgxPlaceholder: '你想用 ManimGX 生成什么动画？',
    threejsPlaceholder: '你想作出怎样的3D模型',
    geogebraPlaceholder: '你想绘制怎样的几何图形',
    solvePlaceholder: '请输入您的数学题目或上传题目图片...',
    qqPlaceholder: '请描述您需要分析拆解的问题...',
    
    // 提示词推荐
    suggestions: {
      manim: [
        "高中化学与初中数学的区别是啥",
        "什么是DNA",
        "展示两个向量相加的几何意义"
      ],
      threejs: [
        "创建一个三棱锥及其外接球",
        "动量守恒定律",
        "正方体及其内切球"
      ],
      solve: [
        "解 x^2 + 5x + 6 = 0",
        "函数 f(x) = x * sin(x) 的导数",
        "化简表达式 (x+1)^3 - x^3"
      ],
      geogebra: [
        "画一个三角形及其外接圆",
        "绘制函数 y = sin(x)/x 的图像",
        "演示抛物线的焦点和准线性质"
      ],
      qq: [
        "分析这道几何题的解题思路",
        "拆解牛顿第二定律的应用步骤",
        "如何证明三角形内角和为180度？",
        "解释微积分基本定理的直观含义"
      ]
    },
    
    // 解题模式
    solving: '正在解题分析...',
    solved: '解题完成',
    videoReady: '视频已就绪',
    generatingVideo: '正在生成视频讲解...',
    videoTitle: '讲解视频',
    videoPlaceholder: '完成解题分析后，点击左侧"视频讲解"按钮生成动画教学视频',
    videoPlaceholder2: '完成解题分析后，点击"视频讲解"按钮生成动画教学视频',
    solutionVideo: '解题视频',
    
    threeDViewOn: '3D视图已开启',
    threeDView: '3D视图',
    
    needVoiceover: '是否需要语音旁白？',
    cancelGenerate: '取消生成',
    baseCost: '基础消耗',
    extraAudioCost: '+音频额外',
    yesLabel: '是',
    noLabel: '否',
    
    // 页脚
    realScenarios: '【真实应用场景】',
    
    // ========== 登录/注册页 ==========
    userLogin: '用户登录',
    loginToUse: '登录以使用Hammerath',
    passwordLogin: '密码登录',
    codeLogin: '验证码登录',
    emailAddress: '邮箱地址',
    enterEmail: '请输入邮箱',
    password: '密码',
    enterPassword: '请输入密码',
    verificationCode: '验证码',
    enterCode: '请输入验证码',
    sendCode: '发送验证码',
    resendAfter: '秒后重发',
    login: '登录',
    loggingIn: '登录中...',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    
    // 注册
    userRegistration: '用户注册',
    registerToUse: '注册以使用Hammerath',
    username: '用户名',
    enterUsername: '请输入用户名',
    confirmPassword: '确认密码',
    enterConfirmPassword: '请再次输入密码',
    register: '注册',
    registering: '注册中...',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    
    // 特色标签
    allSubjects: '全学科支持',
    aiGeneration: 'AI智能生成',
    animationVisualization: '动画可视化',
    globalFirst: '浩瀚启蒙，所想即视',
    
    // ========== 作品展示页 ==========
    showcase: '作品展示',
    backToHome: '返回首页',
    allCategories: '全部分类',
    difficulty: '难度',
    all: '全部',
    easy: '简单',
    medium: '中等',
    hard: '困难',
    filterByCategory: '按分类筛选',
    filterByDifficulty: '按难度筛选',
    noWorks: '暂无作品',
    loading: '加载中...',
    viewDetail: '查看详情',
    sortLatest: '最新发布',
    sortMostViewed: '最多浏览',
    sortMostLiked: '最多点赞',
    backToCreate: '返回创作',
    showcaseTitle: '作品展示',
    showcaseSubtitle: '来逛逛吧，看看有没有你需要的？',
    searchPlaceholder: '搜索关键词（支持搜索标题、提示词、代码内容等）...',
    featuredWorks: '精选作品',
    sortByLabel: '排序：',
    emptyTitle: '找不到想要的？',
    emptySubtitle: '自己尝试制作一个吧！',
    startCreating: '开始创作',
    featured: '精选',
    prevPage: '上一页',
    nextPage: '下一页',
    paginationInfo: '第 {page} 页 / 共 {totalPages} 页（共 {total} 个作品）',
    defaultShowcaseTitle: '数学动画作品',
    copyFailed: '复制失败，请手动复制代码',
    workNotFound: '作品不存在',
    backToList: '返回列表',
    videoNotSupported: '您的浏览器不支持视频播放',
    noVideo: '暂无视频',
    liked: '已点赞',
    like: '点赞',
    share: '分享',
    views: '次浏览',
    authorLabel: '作者：',
    promptTitle: '生成提示词',
    manimCodeTitle: 'Manim代码',
    ggbCodeTitle: 'GeoGebra指令',
    htmlCodeTitle: 'HTML/JS代码',
    manimCodeSubtitle: '供学习参考或者微调',
    copyCodeTooltip: '快速复制代码',
    copied: '已复制',
    copyCode: '复制代码',
    hideCode: '隐藏代码',
    showCode: '显示代码',
    tagsTitle: '标签',

    // ========== 个人信息页 ==========
    userInfoError: '用户信息异常，请重新登录',
    getUserInfoFailed: '获取用户信息失败',
    getUserInfoFailedRetry: '获取用户信息失败，请稍后重试',
    usernameTooShort: '用户名至少需要2个字符',
    usernameTooLong: '用户名不能超过50个字符',
    usernameContainsSensitiveWord: '用户名包含不当内容，请修改后重试',
    usernameInvalidCharacters: '用户名只能包含中文、英文、数字、下划线和短横线',
    updateSuccess: '用户信息更新成功！',
    updateFailed: '更新用户信息失败',
    updateFailedRetry: '更新用户信息失败，请稍后重osi',
    loadUserFailed: '无法加载用户信息',
    back: '返回',
    profileTitle: '个人信息',
    basicInfo: '基本信息',
    emailLabel: '邮箱',
    usernameLabel: '用户名',
    usernamePlaceholder: '请输入用户名（2-50个字符）',
    notSet: '未设置',
    creditsLabel: '剩余积分',
    registerDateLabel: '注册时间',
    lastLoginLabel: '最后登录',
    saving: '保存中...',
    editInfo: '编辑信息',
    changePassword: '修改密码',
    logout: '退出系统',
    myRepository: '我的作品仓库',
    repositoryDesc: '查看和管理您的所有创作',
    viewMyWorks: '进入我的仓库',
    
    // ========== 我的作品页 ==========
    myWorks: '我的作品',
    backToProfile: '返回个人中心',
    sortBy: '排序',
    noWorksYet: '还没有作品',
    startCreatingHint: '开始创作您的第一个作品吧！',
    untitled: '未命名作品',
    hideWork: '隐藏此作品',
    unhideWork: '取消隐藏',
    renameWork: '重命名作品',
    renameWorkPrompt: '请输入新的作品名称',
    renameWorkEmpty: '作品名称不能为空',
    renameWorkSuccess: '重命名成功',
    renameWorkFailed: '重命名失败，请稍后重试',
    hiddenWorksSection: '隐藏的作品',
    hiddenWorksDesc: '以下作品已从仓库隐藏，但在作品展示区仍可见',
    noHiddenWorks: '暂无隐藏作品',
    hiddenBadge: '已隐藏',

    // ========== 错误提示 ==========
    emailRequired: '邮箱不能为空',
    passwordRequired: '密码不能为空',
    codeRequired: '验证码不能为空',
    usernameRequired: '用户名不能为空',
    passwordMismatch: '两次输入的密码不一致',
    
    // ========== 其他通用 ==========
    confirm: '确认',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    submit: '提交',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '提示',
    
    // ========== 新手引导 ==========
    // 欢迎页
    tutorialWelcomeTitle: '欢迎来到 HAMMERATH ！',
    tutorialWelcomeBadge: '【浩瀚启蒙，所想即视】',
    tutorialWelcomeIntro: '我是你的智能助手，将带你 1 分钟快速了解如何使用本平台。',
    tutorialWelcomeSub: '点击"下一步"开启你的创作之旅 🚀',
    
    // 核心功能模式
    tutorialModesTitle: '选择创作模式',
    tutorialModesIntro: '悬停在提交按钮上，即可切换不同的 AI 创作模式：',
    tutorialModeManim: '平面动画：',
    tutorialModeManimDesc: '输入描述即可自动生成 2D 数学动画视频，教学更直观。',
    tutorialMode3D: '3D模式：',
    tutorialMode3DDesc: '快速创建可交互、自由旋转缩放的 3D 几何模型。',
    tutorialModeGGB: 'GGb模式：',
    tutorialModeGGBDesc: '智能生成 GeoGebra 指令，动态演绎几何关系。',
    tutorialModesTip: '💡 提示：鼠标悬停在模式选择器上可自由切换全部可用模式',
    
    // 输入需求
    tutorialInputTitle: '输入创作需求',
    tutorialInputIntro: '在胶囊输入框中，用自然语言写下你想要生成的数学场景：',
    tutorialInputTip1: '描述得越清晰详细，AI 生成的可视化效果越完美。',
    tutorialInputTip2: '支持点击左侧按钮上传图片（如题目图、示意图）作为辅助。',
    tutorialInputExample: '示例：',
    tutorialInputExampleText: '"泰勒展开式的几何意义"',
    tutorialInputTipBottom: '💡 提示：用文字或图片详述你的创意，剩下的交给 AI 即可！',
    
    // 导航栏统一提示
    tutorialTopbarTitle: '快捷导航栏',
    tutorialTopbarIntro: '点击顶部下拉，即可查看导航菜单、灵动快捷岛、个人中心与积分等全部功能信息。',
    tutorialTopbarTip: '💡 提示：点击顶部的下拉按钮，随时展开或收起导航栏。',
    
    // 灵动胶囊
    tutorialIslandTitle: '灵动快捷岛',
    tutorialIslandIntro: '页面顶部的灵动岛是你的高频功能快捷区：',
    tutorialIslandTip1: '按住并拖拽导航下拉菜单中的任意选项到此处。',
    tutorialIslandTip2: '一键点击直达常用页面，大幅提升创作效率。',
    tutorialIslandTipBottom: '💡 提示：长按功能图标拖动到灵动岛即可轻松绑定！',

    // 导航菜单
    tutorialShowcaseTitle: '导航菜单',
    tutorialShowcaseIntro: '点击左上角“导航”展开丰富功能：',
    tutorialShowcaseTip1: 'H-Board 智能白板：手写绘画，AI 自动整理内容。',
    tutorialShowcaseTip2: '作品展示区：浏览其他用户的精选数学场景，获取无限创意灵感。',
    tutorialShowcaseTipBottom: '💡 提示：点击即可直达相应功能，开启全新探索。',
    
    // 个人设置与积分
    tutorialCreditsTitle: '个人中心与积分',
    tutorialCreditsIntro: '点击右上角“我的”头像可以管理你的个人账户：',
    tutorialCreditsNew: '账户积分：',
    tutorialCreditsNewDesc: '查看你当前的使用次数，每日签到即可免费领福利。',
    tutorialCreditsModes: '加入社群：',
    tutorialCreditsModesDesc: '免费获取更多积分兑换码、官方最新资讯与专属技术支持！',
    tutorialCreditsTip: '💡 提示：每日签到和参与社群活动，海量积分轻松领！',

    // 完成页
    tutorialCompleteTitle: '开启精彩创作！',
    tutorialCompleteIcon: '✨',
    tutorialCompleteIntro: '恭喜你完成新手引导！',
    tutorialCompleteMain: '你已完全掌握了 Hammerath AI 的核心操作技巧。',
    tutorialCompleteTipsTitle: '💡 快速备忘：',
    tutorialCompleteTip1: '遇到问题？可随时查看案例指南或向社群求助。',
    tutorialCompleteTip2: '记得收藏本站，随时随地开启你的可视化数学创作之旅！',
    tutorialCompleteCTA: '快去描述你的第一个精彩构想吧！🚀',
    
    // 引导按钮
    tutorialStepProgress: '步骤',
    tutorialPrevButton: '上一步',
    tutorialNextButton: '下一步',
    tutorialSkipButton: '跳过引导',
    tutorialStartButton: '开始创作',
    tutorialKeyboardHint1: '← → 切换步骤',
    tutorialKeyboardHint2: 'ESC 退出',
    
    // ========== 模式名称翻译（客户端翻译数据库内容）==========
    modeNameManim: '平面动画模式',
    modeNameManimgx: 'ManimGX模式',
    modeNameThreejs: '3D模式',
    modeNameGeogebra: 'GGb模式',
    modeNameSolve: '锤锤解题',
    modeNameQQ: 'QQ模式',
    modeDescManim: '一键生成数学动画视频',
    modeDescManimgx: '高性能扩展动画渲染引擎',
    modeDescThreejs: '创建交互式3D可视化',
    modeDescGeogebra: '动态几何图形绘制',
    modeDescSolve: '智能解题+视频讲解',
    modeDescQQ: '问题拆解可视化',
    modeInputPlaceholder: '描述你想要的动画',
    modeUploadImage: '上传截图片',
    modeGenerateButton: '生成动画',
    switchToSolve: '切换到解题模式',
    expandHint: '悬停查看更多模式',
    costLabel: '消耗：',
    limitedTime: '限时',
    creditsPerTime: '积分/次',

    // ========== 公告弹窗 ==========
    systemAnnouncement: '系统公告',
    noAnnouncements: '暂无公告',
    dontShowAgainHint: '点击下方按钮后今日不再弹出',
    confirmKnow: '我知道了，不再提示',
    closeHint: '关闭（今日不再提示）',
    
    // 灵动岛 (Dynamic Island)
    islandShowcase: '作品展示区',
    islandMyWorks: '个人仓库',
    islandGuideTitle: '常用入口胶囊',
    islandGuideDesc: '将左侧导航中的功能拖拽到此处，即可一键快速到达',
    islandGuideClose: '关闭提示',
    islandRemoveShortcut: '从快捷入口移除',
    islandDropToAdd: '松开即可添加',
    islandDragToPin: '拖入导航入口即可固定',
    
    // 导航菜单
    dragToCapsuleHint: '拖拽入口至顶部胶囊可快速访问',
    draggableToCapsule: '可拖拽到顶部快捷入口',
    dragToTopCapsule: '拖拽到顶部胶囊',
    myWorksDesc: '查看我的所有作品',
    
    // InputArea 组件文本
    creditsUnit: '积分',
    deepThinking: '深度思考',
    deepThinkingHint: '(耗时更长)',
    deepThinkingTooltip: '深度思考：生成前由AI专家进行多步深度推理与专业脚本修饰，等待时间更长，生成质量更佳',
    freeModeTitle: '免费',
    appScene: '适用场景',
    modeExplanationSceneManim: '生成专业精致的数学、几何、物理等教学动画，适合微课、教案展示和自媒体内容创作。',
    modeExplanationSceneManimgx: '基于 ManimGX 引擎的高性能动画生成，支持现代化扩展语法与极速渲染。',
    modeExplanationSceneGeogebra: '绘制2D或3D函数图像与动态几何画板，适合在课堂或白板上进行交互式数学演示与作图。',
    modeExplanationSceneThreejs: '构建交互式3D空间场景，适合立体几何、空间立体图像的可视化展示及自由拖拽交互。',
    modeExplanationSceneSolve: '针对数学与物理的公式、图形和多步骤题目进行智能深度解析，给出详细解题步骤与答案。',
    modeExplanationSceneQq: '将复杂的概念或知识结构一键生成清晰的交互式思维导图/概念图，适合快速梳理知识脉络。',
    inputTitleManim: '描述你想要的动画',
    inputTitleManimgx: '描述你想要的 ManimGX 动画',
    inputTitleThreejs: '描述你想要的3D演示',
    inputTitleGeogebra: '描述你想要绘制的图形',
    inputTitleSolve: '输入你的任何题目',
    inputTitleQQ: '描述你需要分析的问题',
    inputButtonManim: '生成动画',
    inputButtonManimgx: '生成 ManimGX 动画',
    inputButtonThreejs: '生成交互演示',
    inputButtonGeogebra: '生成GeoGebra指令',
    inputButtonSolve: '开始解题',
    inputUploadButton: '上传图片',
    inputRemoveImage: '移除图片',
    inputFileSizeError: '图片大小不能超过5MB',
    inputFileTypeError: '请上传图片文件（JPG, PNG, GIF等）',
    inputUploadImage: '上传题目图片',
    inputChangeImage: '更换图片',
    inputCharCount: '个字符',
    inputGenerating: '生成中...',
    currentMode: '当前模式',
    clickToGenerate: '点击生成',
    clickToFill: '点击填入',
    previewImage: '预览图片',

    // AI修饰功能
    aiEnhance: 'AI修饰',
    aiEnhanceTooltip: '使用AI优化提示词，生成详细画面脚本',
    aiEnhanceTitle: 'AI修饰',
    aiEnhancePlaceholder: '继续对话，进一步优化脚本...',
    accept: '接受并使用',
    copy: '复制',

    // 导航菜单
    browseFeaturedWorks: '浏览精选作品',
    quickStartGuide: '快速上手教程',
    partnership: '校企合作',
    partnershipDesc: '了解合作方案与定价',
    downloadAndroid: '下载 Android 客户端',
    downloadAndroidDesc: '扫码或直接下载 App v1.0',
    downloadQRTitle: '扫码下载 Android 客户端',
    downloadQRSubtitle: 'HAMMERATH App v1.0',
    downloadQRScanHint: '微信扫一扫，直接下载到手机',
    downloadQRStep1: '打开微信，点击右上角"＋"',
    downloadQRStep2: '选择"扫一扫"扫描上方二维码',
    downloadQRStep3: '在浏览器中打开并下载安装',
    downloadQRDirectBtn: '在电脑上直接下载',
    downloadQRVersion: '版本 1.0 · 仅支持 Android 系统',

    // ========== 校企合作页 (Enterprise & Education) ==========
    partnershipNavTag: '校企合作与机构授权',
    partnershipTitle: '校企合作与机构授权',
    partnershipSubtitle: '专业 AI 科学可视化教研方案 · 4 账号起售 · 购买越多单价越低',

    // 核心方案与专属权益 (少而精：无限次使用 + 1v1售后教程辅导)
    planBadge: '全年无限次',
    planName: '企业 / 院校标准席位',
    partnershipPricingSubtitle: '明码标价 · 4 个账号起售 · 多买更优惠',
    planPriceNum: '1,500',
    planPriceUnit: '元 / 账号 / 年',
    planMinNotice: '⚡ 4 个账号起拍（¥6,000 / 年起）',
    volumeDiscountSummary: '支持梯度优惠：批量采购单价低至 ¥1,000 / 账号 / 年',
    perkUnlimitedTitle: '全年无限次使用',
    perkUnlimitedDesc: '全功能模块无限次生成，不限次数与额度，满足全年教学教研',
    perkTrainingTitle: '1v1 售后教程辅导',
    perkTrainingDesc: '专人专属一对一实操指导与答疑，保障快速掌握课件制作',
    planTrustText: '支持开具正规增值税专用/普通发票 · 支持公对公银行转账',

    // 梯度计价标签 (用于测算卡片)
    discountTierBase: '起步基准价',
    discountTier8: '9折特惠 · 省 ¥150/席',
    discountTier16: '8折特惠 · 省 ¥300/席',
    discountTier30: '特惠底价 · 省 ¥500/席',
    totalSavedPrefix: '已享梯度优惠累计减免 ¥',

    // 席位测算器
    calcTitle: '席位费用梯度测算',
    calcSubtitle: '自选账号数量，实时享受阶梯单价优惠',
    calcPreset4: '4 席 (¥1,500/个)',
    calcPreset8: '8 席 (¥1,350/个)',
    calcPreset16: '16 席 (¥1,200/个)',
    calcPreset30: '30 席 (¥1,000/个)',
    calcAccountCount: '席位数量',
    calcAccountsUnit: '个',
    calcMinLimitNote: '（4 个起拍）',
    calcTotalFee: '全年总投入',
    calcPerYear: '/ 年',
    calcOrderCta: '复制邮箱咨询开通',
    calcCustomTier: '全校级 / 私有化部署定制需求？',
    calcCustomTierLink: '邮件咨询获取定制方案',

    // 极简流程
    partnershipProcess: '合作流程',
    step1Title: '01 咨询需求',
    step2Title: '02 确认合同',
    step3Title: '03 对公付款',
    step4Title: '04 开通交付',

    // 商务咨询与联系 (纯净复制邮箱)
    contactUs: '商务咨询与合作',
    contactSubtitle: '专人将在工作日 2 小时内极速响应您的邮件需求',
    contactEmailTitle: '官方商务联系邮箱',
    contactCopyEmail: '复制邮箱地址',
    contactCopied: '邮箱已复制！',
    emailTemplateTitle: '💡 邮件建议注明：单位名称 · 席位数量 · 联系电话',
    invoiceDescShort: '支持开具正规增值税专用发票、普通发票及公对公银行转账，资质合规完备。',
    compVatSpecial: '增值税专用发票',
    compVatOrdinary: '增值税普通发票',
    compContract: '正规合同签署',
    compTransfer: '公对公银行转账',

    // 合作单位
    ourPartners: '合作单位',
    partnersSubtitle: '携手众多高校与教育科研机构',

    // 设置菜单
    settings: '我的',
    userInfo: '用户信息',
    viewProfile: '点击查看个人信息',
    languageSettings: '语言设置',
    unnamedUser: '未命名用户',
    user: '用户',
    logout: '退出登录',
  },
  en: {
    // ========== Landing page ==========
    platformTitle: 'Make Visualization ',
    platformSubtitle: 'Easy to Achieve',
    platformSuffix: '',
    thinkIt: 'Think It',
    connector: '',
    getIt: 'Get It',
    thinkGetEn: 'THINK IT, GET IT',
    logoChinese: '',
    startExperience: 'Get Started',
    scrollDownToExplore: 'Scroll down to explore',
    poweredBy: 'Powered by Advanced AI Technology',
    whatCanIDo: 'What Can I Do?',
    realScenariosTitle: 'Real Application Scenarios',
    realScenariosSub: 'Lectures · Papers · Competitions · Projects · Micro-lessons',
    
    // Feature cards
    mathAnimation: 'Math Animation',
    interactive3D: '3D Interactive',
    geometry: 'Geometry Drawing',
    smartSolve: 'Smart Solver',
    
    // Language options
    language: 'Language',
    chinese: '中文',
    english: 'English',
    
    // ========== Home Page ==========
    // Header
    navigation: 'Menu',
    showcaseGallery: 'Exhibition',
    newUserGuide: 'Guide',
    logoTitle: 'HAMMERATH',
    welcomeUser: 'see the unseen!',
    guest: 'Guest',
    welcomeUserSeparator: ', ',
    tagline: 'Think it, Get it',
    taglineEn: 'Think it, Get it',
    remainingCredits: 'Credits',
    getMoreCredits: 'More Credits',
    purchasedCredits: 'Purchased',
    bonusCreditsLabel: 'Bonus',
    expireAtMonthEnd: 'Expires at month end',
    
    // Loading states
    analyzing: 'Analyzing question...',
    understanding: 'Understanding requirements...',
    building: 'Building solution strategy...',
    deriving: 'Deriving step by step...',
    verifying: 'Verifying solution steps...',
    organizing: 'Organizing solution...',
    parsing: 'Parsing your request...',
    constructing: 'Constructing mathematical model...',
    generating: 'Generating code framework...',
    filling: 'Filling core logic...',
    optimizing: 'Optimizing code structure...',
    completing: 'Almost done, please wait...',

    // Recommended works
    recommendedInspirations: 'Recommended Inspirations',
    recommendedWhileWaiting: 'Explore related creations while waiting',
    personalizedRecommendations: 'Tailored to your recent interests and current topic',
    previewWork: 'Preview Work',
    previewWorkDesc: 'Click to view details and preview',
    generatingInProgress: 'Generating your creation',
    generationCompleteNotice: 'Your creation is ready!',
    viewGenerationResult: 'View Result',
    openInNewTab: 'Open in new tab',
    noSimilarShowcase: 'Curated featured works for your inspiration',
    indexedKeywords: 'Indexed keywords',
    matchedKeywordsPrefix: 'Matched with',
    matchedKeywordsSuffix: 'for your current topic',

    loadingProgress: 'Progress',
    manimLoadingTexts: [
      "Parsing your request...",
      "Building mathematical model...",
      "Generating initial code framework...",
      "Filling core logic...",
      "Optimizing code structure...",
      "Almost done, please wait..."
    ],
    solveLoadingTexts: [
      "Analyzing question...",
      "Understanding requirements...",
      "Building solution strategy...",
      "Deriving step by step...",
      "Verifying solution steps...",
      "Organizing solution..."
    ],
    solveVideoLoadingTexts: [
      "Generating video explanation...",
      "Drawing geometric shapes...",
      "Adding animation effects...",
      "Synthesizing voiceover...",
      "Rendering video frames...",
      "Almost done..."
    ],
    threejsLoadingTexts: [
      "Parsing your request...",
      "Building 3D interactive model...",
      "Generating HTML structure...",
      "Configuring interactive controls...",
      "Optimizing rendering performance...",
      "Almost done, please wait..."
    ],
    geogebraLoadingTexts: [
      "Parsing geometric requirements...",
      "Analyzing graph structure...",
      "Generating GeoGebra commands...",
      "Optimizing drawing order...",
      "Configuring graph styles...",
      "Almost done, please wait..."
    ],
    qqLoadingTexts: [
      "Analyzing problem structure...",
      "Identifying core elements...",
      "Breaking down problem chains...",
      "Building logical relationships...",
      "Generating visual interface...",
      "Optimizing interaction experience...",
      "Almost done, please wait..."
    ],
    
    // Buttons and actions
    return: 'Back',
    autoSavedToRepoPrefix: 'The work has been automatically saved to your ',
    autoSavedToRepoSuffix: ' for you to download anytime.',
    repository: 'Repository',
    refineIt: 'Not satisfied? Try to refine it',
    preview: 'Animation Preview',
    viewEffect: 'View 3D Effect',
    videoExplanation: 'Video Explanation',
    generating: 'Generating...',
    fixCode: 'Fix Code',
    fixing: 'Fixing...',
    noImageFix: 'No Image? Fix It',
    
    // Errors and prompts
    renderError: 'Render Error',
    pleaseInputDescription: 'Please enter your description',
    insufficientCredits: 'Insufficient credits, please join the community to get more',
    loadingProgress: 'Progress',
    welcomeAI4GGB: 'Welcome to AI4GGB! Please describe the geometric shape or mathematical function you want to draw, and AI will generate GeoGebra commands for you.',
    welcomeSolve: 'Welcome to Hammer Solve! Please enter your math problem or upload a problem image, and AI will provide detailed solution analysis.',
    welcome3D: 'Welcome to 3D mode! Please describe the geometric shape or mathematical function you want to draw...',
    welcomeQQ: 'Welcome to QQ mode! Please describe the problem you need to analyze...',
    generationComplete: 'Generation complete!',
    qqAnalysisComplete: 'Problem breakdown complete! Click the button below to review',
    view3DEnabled: '3D View Enabled',
    view3DDisabled: '3D View',
    animationPreview: 'Animation Preview',
    refineIt: 'Not satisfied? Try to refine it',
    autoSavedToRepoPrefix: 'Tip: This work has been automatically saved to your ',
    autoSavedToRepoSuffix: '.',
    repository: 'repository',
    needVoiceover: 'Do you need a voiceover?',
    baseCost: 'Base cost',
    extraAudioCost: '+ Audio extra',
    yesLabel: 'Yes',
    noLabel: 'No',
    cancelGenerate: 'Cancel generation',
    
    // Mode selection
    hoverForMore: 'Hover to see more modes',
    costLabel: 'Cost',
    limitedTime: 'Limited Time',
    creditsPerUse: 'credits/use',
    
    // Input placeholders
    inputPlaceholder: 'What animation do you want to see?',
    manimgxPlaceholder: 'What animation do you want to generate with ManimGX?',
    threejsPlaceholder: 'What kind of 3D model do you want to create?',
    geogebraPlaceholder: 'What geometric shape do you want to draw?',
    solvePlaceholder: 'Enter your math problem or upload an image...',
    qqPlaceholder: 'Describe the problem you want to analyze...',
    
    // Suggestions
    suggestions: {
      manim: [
        "What's the difference between high school chemistry and middle school math",
        "What is DNA",
        "Show the geometric meaning of adding two vectors"
      ],
      threejs: [
        "Create a triangular pyramid and its circumscribed sphere",
        "Law of conservation of momentum",
        "Cube and its inscribed sphere"
      ],
      solve: [
        "Solve x^2 + 5x + 6 = 0",
        "Derivative of function f(x) = x * sin(x)",
        "Simplify the expression (x+1)^3 - x^3"
      ],
      geogebra: [
        "Draw a triangle and its circumscribed circle",
        "Plot the graph of function y = sin(x)/x",
        "Demonstrate the focus and directrix properties of a parabola"
      ],
      qq: [
        "Analyze the problem-solving strategy for this geometry question",
        "Break down the application steps of Newton's second law",
        "How to prove the sum of interior angles of a triangle is 180 degrees?",
        "Explain the intuitive meaning of the Fundamental Theorem of Calculus"
      ]
    },
    
    // Solve mode
    solving: 'Solving...',
    solved: 'Solution Complete',
    videoReady: 'Video Ready',
    generatingVideo: 'Generating video explanation...',
    videoTitle: 'Explanation Video',
    videoPlaceholder: 'After completing the solution analysis, click "Video Explanation" button to generate animated teaching video',
    videoPlaceholder2: 'After completing the solution analysis, click "Video Explanation" button to generate animated teaching video',
    solutionVideo: 'Solution Video',
    
    threeDViewOn: '3D View On',
    threeDView: '3D View',
    
    needVoiceover: 'Need voiceover?',
    cancelGenerate: 'Cancel Generation',
    baseCost: 'Base Cost',
    extraAudioCost: '+ Extra for Audio',
    yesLabel: 'Yes',
    noLabel: 'No',
    
    // Footer
    realScenarios: '【Real Application Scenarios】',
    
    // ========== Login/Register ==========
    userLogin: 'User Login',
    loginToUse: 'Login to use Hammerath',
    passwordLogin: 'Password',
    codeLogin: 'Verification Code',
    emailAddress: 'Email Address',
    enterEmail: 'Enter email',
    password: 'Password',
    enterPassword: 'Enter password',
    verificationCode: 'Verification Code',
    enterCode: 'Enter verification code',
    sendCode: 'Send Code',
    resendAfter: 's to resend',
    login: 'Login',
    loggingIn: 'Logging in...',
    noAccount: "Don't have an account?",
    registerNow: 'Register Now',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    
    // Registration
    userRegistration: 'User Registration',
    registerToUse: 'Register to use Hammerath',
    username: 'Username',
    enterUsername: 'Enter username',
    confirmPassword: 'Confirm Password',
    enterConfirmPassword: 'Re-enter password',
    register: 'Register',
    registering: 'Registering...',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    
    // Feature badges
    allSubjects: 'All Subjects',
    aiGeneration: 'AI Generation',
    animationVisualization: 'Animation Viz',
    globalFirst: "Think it, Get it.",
    
    // ========== Showcase Page ==========
    showcase: 'Showcase Wall',
    backToHome: 'Back to Home',
    allCategories: 'All Categories',
    difficulty: 'Difficulty',
    all: 'All',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
    filterByCategory: 'Filter by Category',
    filterByDifficulty: 'Filter by Difficulty',
    noWorks: 'No works yet',
    loading: 'Loading...',
    viewDetail: 'View Detail',
    sortLatest: 'Latest',
    sortMostViewed: 'Most Viewed',
    sortMostLiked: 'Most Liked',
    backToCreate: 'Back to Create',
    showcaseTitle: 'Showcase Wall',
    showcaseSubtitle: 'Come and see if there is anything you need.',
    searchPlaceholder: 'Search keywords (title, prompt, code, etc.)...',
    featuredWorks: 'Featured',
    sortByLabel: 'Sort by:',
    emptyTitle: 'Can\'t find what you want?',
    emptySubtitle: 'Try to make one yourself!',
    startCreating: 'Start Creating',
    featured: 'Featured',
    prevPage: 'Previous',
    nextPage: 'Next',
    paginationInfo: 'Page {page} of {totalPages} ({total} works)',
    defaultShowcaseTitle: 'Math Animation Work',
    copyFailed: 'Failed to copy, please copy the code manually',
    workNotFound: 'Work not found',
    backToList: 'Back to List',
    videoNotSupported: 'Your browser does not support video playback',
    noVideo: 'No video available',
    liked: 'Liked',
    like: 'Like',
    share: 'Share',
    views: 'views',
    authorLabel: 'Author: ',
    promptTitle: 'Generation Prompt',
    manimCodeTitle: 'Manim Code',
    ggbCodeTitle: 'GeoGebra Commands',
    htmlCodeTitle: 'HTML/JS Code',
    manimCodeSubtitle: 'For learning, reference or fine-tuning',
    copyCodeTooltip: 'Quickly copy the code',
    copied: 'Copied',
    copyCode: 'Copy Code',
    hideCode: 'Hide Code',
    showCode: 'Show Code',
    tagsTitle: 'Tags',

    // ========== Profile Page ==========
    userInfoError: 'User information is abnormal, please log in again',
    getUserInfoFailed: 'Failed to get user information',
    getUserInfoFailedRetry: 'Failed to get user information, please try again later',
    usernameTooShort: 'Username must be at least 2 characters long',
    usernameTooLong: 'Username cannot exceed 50 characters',
    usernameContainsSensitiveWord: 'Username contains inappropriate content, please modify and try again',
    usernameInvalidCharacters: 'Username can only contain Chinese characters, letters, numbers, underscores and hyphens',
    updateSuccess: 'User information updated successfully!',
    updateFailed: 'Failed to update user information',
    updateFailedRetry: 'Failed to update user information, please try again later',
    loadUserFailed: 'Unable to load user information',
    back: 'Back',
    profileTitle: 'Profile',
    basicInfo: 'Basic Information',
    emailLabel: 'Email',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Enter username (2-50 characters)',
    notSet: 'Not set',
    creditsLabel: 'Remaining Credits',
    registerDateLabel: 'Registration Date',
    lastLoginLabel: 'Last Login',
    saving: 'Saving...',
    editInfo: 'Edit Profile',
    changePassword: 'Change Password',
    logout: 'Logout',
    myRepository: 'My Works Repository',
    repositoryDesc: 'View and manage all your creations',
    viewMyWorks: 'Enter My Repository',
    
    // ========== My Works Page ==========
    myWorks: 'My Works',
    backToProfile: 'Back to Profile',
    sortBy: 'Sort by',
    noWorksYet: 'No works yet',
    startCreatingHint: 'Start creating your first work!',
    untitled: 'Untitled Work',
    hideWork: 'Hide this work',
    unhideWork: 'Unhide',
    renameWork: 'Rename work',
    renameWorkPrompt: 'Enter a new work title',
    renameWorkEmpty: 'Work title cannot be empty',
    renameWorkSuccess: 'Renamed successfully',
    renameWorkFailed: 'Rename failed, please try again later',
    hiddenWorksSection: 'Hidden Works',
    hiddenWorksDesc: 'These works are hidden from your repository but still visible in the showcase',
    noHiddenWorks: 'No hidden works',
    hiddenBadge: 'Hidden',

    // ========== Error Messages ==========
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    codeRequired: 'Verification code is required',
    usernameRequired: 'Username is required',
    passwordMismatch: 'Passwords do not match',
    
    // ========== Other Common ==========
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    submit: 'Submit',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    
    // ========== Tutorial ==========
    // Welcome
    tutorialWelcomeTitle: 'Welcome to HAMMERATH!',
    tutorialWelcomeBadge: '【Think It, Get It】',
    tutorialWelcomeIntro: "I'm your AI assistant, here to show you how to use this platform in just 1 minute.",
    tutorialWelcomeSub: 'Click "Next" to start your creative journey 🚀',
    
    // Core Modes
    tutorialModesTitle: 'Select Creative Mode',
    tutorialModesIntro: 'Hover over the submit button to switch between AI generation modes:',
    tutorialModeManim: '2D Animation:',
    tutorialModeManimDesc: 'Generate stunning mathematical animation videos instantly.',
    tutorialMode3D: '3D Mode:',
    tutorialMode3DDesc: 'Create interactive 3D models with full rotation and zooming.',
    tutorialModeGGB: 'GGB Mode:',
    tutorialModeGGBDesc: 'Intelligently generate GeoGebra commands to dynamically show geometry.',
    tutorialModesTip: '💡 Tip: Hover to reveal and switch between all available modes.',
    
    // Input
    tutorialInputTitle: 'Describe Your Idea',
    tutorialInputIntro: 'Write what mathematical scene you want to generate in the input capsule:',
    tutorialInputTip1: 'Clearer and more detailed descriptions result in perfect visualization.',
    tutorialInputTip2: 'Click the image icon to upload diagrams or question images as aid.',
    tutorialInputExample: 'Example:',
    tutorialInputExampleText: '"Geometric meaning of Taylor expansion"',
    tutorialInputTipBottom: '💡 Tip: Just describe your concept, and let the AI do the rest!',
    
    // Top Navigation Bar
    tutorialTopbarTitle: 'Navigation Bar',
    tutorialTopbarIntro: 'Click the top drop-down to access Navigation Menu, Dynamic Island, and Profile & Credits.',
    tutorialTopbarTip: '💡 Tip: Click the top arrow indicator to expand or collapse the bar.',
    
    // Dynamic Island
    tutorialIslandTitle: 'Dynamic Capsule Island',
    tutorialIslandIntro: 'The Dynamic Island at the top serves as your shortcut area:',
    tutorialIslandTip1: 'Drag and drop any option from the Navigation Menu here.',
    tutorialIslandTip2: 'Access your favorite pages in one click to boost your workflow.',
    tutorialIslandTipBottom: '💡 Tip: Drag items directly into the top island to bind them!',

    // Navigation Menu
    tutorialShowcaseTitle: 'Navigation Menu',
    tutorialShowcaseIntro: 'Click "Navigation" in the top-left to access features:',
    tutorialShowcaseTip1: 'H-Board: Write/draw and let AI automatically organize contents.',
    tutorialShowcaseTip2: 'Showcase Wall: Browse featured mathematical scenes for inspiration.',
    tutorialShowcaseTipBottom: '💡 Tip: Click any option to visit the corresponding feature.',
    
    // Profile & Credits
    tutorialCreditsTitle: 'Profile & Credits',
    tutorialCreditsIntro: 'Click the "My Account" avatar in the top-right to manage your account:',
    tutorialCreditsNew: 'Account Credits:',
    tutorialCreditsNewDesc: 'Check your remaining usage limit and get daily check-in rewards.',
    tutorialCreditsModes: 'Join Community:',
    tutorialCreditsModesDesc: 'Get free credit codes, latest updates, and official support!',
    tutorialCreditsTip: '💡 Tip: Check in daily and join community events for free credits!',

    // Complete
    tutorialCompleteTitle: 'Ready to Create!',
    tutorialCompleteIcon: '✨',
    tutorialCompleteIntro: 'Congratulations on completing the tutorial!',
    tutorialCompleteMain: 'You have mastered all core operations of Hammerath AI.',
    tutorialCompleteTipsTitle: '💡 Quick Tips:',
    tutorialCompleteTip1: 'Need help? Check out our guides or ask the community.',
    tutorialCompleteTip2: 'Bookmark this website to start creating whenever you want!',
    tutorialCompleteCTA: "Go ahead and describe your first mathematical scenario! 🚀",
    
    // Buttons
    tutorialStepProgress: 'Step',
    tutorialPrevButton: 'Previous',
    tutorialNextButton: 'Next',
    tutorialSkipButton: 'Skip Guide',
    tutorialStartButton: 'Start Creating',
    tutorialKeyboardHint1: '← → Switch steps',
    tutorialKeyboardHint2: 'ESC Exit',
    
    // ========== Mode Names Translation (Client-side translation of database content) ==========
    modeNameManim: '2D Animation Mode',
    modeNameManimgx: 'ManimGX Mode',
    modeNameThreejs: '3D Mode',
    modeNameGeogebra: 'GGB Mode',
    modeNameSolve: 'Smart Solver',
    modeNameQQ: 'QQ Mode',
    modeDescManim: 'Generate math animation videos',
    modeDescManimgx: 'High-performance extended animation engine',
    modeDescThreejs: 'Create interactive 3D visualizations',
    modeDescGeogebra: 'Dynamic geometry drawing',
    modeDescSolve: 'Smart solving + video explanation',
    modeDescQQ: 'Problem breakdown visualization',
    modeInputPlaceholder: 'Describe the animation you want',
    modeUploadImage: 'Upload Image',
    modeGenerateButton: 'Generate Animation',
    switchToSolve: 'Switch to Smart Solver',
    expandHint: 'Hover to see more modes',
    costLabel: 'Cost:',
    limitedTime: 'Limited Time',
    creditsPerTime: 'credits/use',

    // ========== Announcement Modal ==========
    systemAnnouncement: 'System Announcement',
    noAnnouncements: 'No announcements',
    dontShowAgainHint: 'Click button below to not show again today',
    confirmKnow: 'Got it, don\'t show again',
    closeHint: 'Close (don\'t show again today)',
    
    // Dynamic Island
    islandShowcase: 'Showcase',
    islandMyWorks: 'My Works',
    islandGuideTitle: 'Dynamic Island',
    islandGuideDesc: 'Drag features from left menu here for one-click access',
    islandGuideClose: 'Close Guide',
    islandRemoveShortcut: 'Remove shortcut',
    islandDropToAdd: 'Drop to add',
    islandDragToPin: 'Drag menu item to pin',
    
    // Navigation Menu
    dragToCapsuleHint: 'Drag to dynamic island for quick access',
    draggableToCapsule: 'Draggable to quick access',
    dragToTopCapsule: 'Drag to top island',
    myWorksDesc: 'View all my works',
    
    // InputArea component texts
    creditsUnit: 'credits',
    deepThinking: 'Deep Think',
    deepThinkingHint: '(Takes longer)',
    deepThinkingTooltip: 'Deep Thinking: AI performs multi-step reasoning and script optimization before generation. Better quality with longer wait time',
    freeModeTitle: 'Free',
    appScene: 'Use Cases',
    modeExplanationSceneManim: 'Generate professional, exquisite math, geometry, and physics teaching animations for micro-classes and presentations.',
    modeExplanationSceneManimgx: 'High-performance animation generation powered by ManimGX engine, with modern syntax and fast rendering.',
    modeExplanationSceneGeogebra: 'Draw 2D/3D functions and dynamic geometry boards, ideal for interactive math demonstrations and plotting.',
    modeExplanationSceneThreejs: 'Build interactive 3D spatial scenes, suitable for visualizing 3D geometry and dragging interaction.',
    modeExplanationSceneSolve: 'Intelligently analyze math and physics problems with multi-step formulas, graphics, and detailed steps.',
    modeExplanationSceneQq: 'Generate interactive mind maps and concept maps from complex ideas for quick knowledge structuring.',
    inputTitleManim: 'Describe the animation',
    inputTitleManimgx: 'Describe the ManimGX animation',
    inputTitleThreejs: 'Describe the 3D demo',
    inputTitleGeogebra: 'Describe the geometry',
    inputTitleSolve: 'Enter your question',
    inputTitleQQ: 'Describe the problem to analyze',
    inputButtonManim: 'Generate Animation',
    inputButtonManimgx: 'Generate ManimGX Animation',
    inputButtonThreejs: 'Generate Demo',
    inputButtonGeogebra: 'Generate GeoGebra',
    inputButtonSolve: 'Start Solving',
    inputUploadButton: 'Upload Image',
    inputRemoveImage: 'Remove Image',
    inputFileSizeError: 'Image size cannot exceed 5MB',
    inputFileTypeError: 'Please upload image files (JPG, PNG, GIF, etc.)',
    inputUploadImage: 'Upload Image',
    inputChangeImage: 'Change Image',
    inputCharCount: 'characters',
    inputGenerating: 'Generating...',
    currentMode: 'Current Mode',
    clickToGenerate: 'Click to Generate',
    clickToFill: 'Click to fill',
    previewImage: 'Preview image',

    // AI Enhance Feature
    aiEnhance: 'Prompt Enhance',
    aiEnhanceTooltip: 'Use AI to optimize prompt and generate detailed scene script',
    aiEnhanceTitle: 'Prompt Enhance',
    aiEnhancePlaceholder: 'Continue the conversation to further refine the script...',
    accept: 'Accept & Use',
    copy: 'Copy',

    // Navigation Menu
    browseFeaturedWorks: 'Browse featured works',
    quickStartGuide: 'Quick start guide',
    partnership: 'Partnership',
    partnershipDesc: 'Learn about plans and pricing',
    downloadAndroid: 'Download Android App',
    downloadAndroidDesc: 'Scan QR or download App v1.0',
    downloadQRTitle: 'Download Android App',
    downloadQRSubtitle: 'HAMMERATH App v1.0',
    downloadQRScanHint: 'Scan with WeChat to download',
    downloadQRStep1: 'Open WeChat, tap "+" in top right',
    downloadQRStep2: 'Tap "Scan" and scan the QR code above',
    downloadQRStep3: 'Open in browser and install',
    downloadQRDirectBtn: 'Direct download on PC',
    downloadQRVersion: 'Version 1.0 · Android only',

    // ========== Partnership Page (Enterprise & Education) ==========
    partnershipNavTag: 'Academic & Enterprise Partnership',
    partnershipTitle: 'Academic & Enterprise Partnership',
    partnershipSubtitle: 'Professional AI visualization solution · Min. 4 accounts · Volume discounts',

    // Plan Info & Core Perks (Unlimited usage + 1-on-1 guidance)
    planBadge: 'Unlimited All Year',
    planName: 'Enterprise / Academic Seats',
    partnershipPricingSubtitle: 'Transparent pricing · Min. 4 accounts · Volume discounts',
    planPriceNum: '1,500',
    planPriceUnit: 'CNY / Seat / Year',
    planMinNotice: '⚡ Min. 4 accounts (From ¥6,000/year)',
    volumeDiscountSummary: 'Tiered volume discounts: As low as ¥1,000 / seat / year',
    perkUnlimitedTitle: 'Unlimited Usage All Year',
    perkUnlimitedDesc: 'Unlimited generations across all modes and features with zero quota caps',
    perkTrainingTitle: '1-on-1 Tutorial Guidance',
    perkTrainingDesc: 'Dedicated specialist for hands-on tutorials, onboarding, and continuous Q&A',
    planTrustText: 'VAT Special/Ordinary Invoices & Corporate Transfer Supported',

    // Tiered calculation labels
    discountTierBase: 'Base Rate',
    discountTier8: '10% Off · Save ¥150/ea',
    discountTier16: '20% Off · Save ¥300/ea',
    discountTier30: 'Special Floor · Save ¥500/ea',
    totalSavedPrefix: 'Volume discount savings: ¥',

    // Seat Calculator
    calcTitle: 'Tiered Seat Cost Calculator',
    calcSubtitle: 'Select seats to preview real-time volume discounts',
    calcPreset4: '4 Seats (¥1,500/ea)',
    calcPreset8: '8 Seats (¥1,350/ea)',
    calcPreset16: '16 Seats (¥1,200/ea)',
    calcPreset30: '30 Seats (¥1,000/ea)',
    calcAccountCount: 'Number of Seats',
    calcAccountsUnit: 'seats',
    calcMinLimitNote: '(Min. 4 accounts)',
    calcTotalFee: 'Total Annual Cost',
    calcPerYear: '/ Year',
    calcOrderCta: 'Copy Email & Order',
    calcCustomTier: 'Campus-wide or private deployment?',
    calcCustomTierLink: 'Inquire via email for custom proposal',

    // Streamlined Process
    partnershipProcess: 'Cooperation Process',
    step1Title: '01 Inquiry',
    step2Title: '02 Contract',
    step3Title: '03 Payment',
    step4Title: '04 Delivery',

    // Contact & Invoicing
    contactUs: 'Business Inquiries & Contact',
    contactSubtitle: 'Our specialist will respond to your email within 2 hours on business days',
    contactEmailTitle: 'Official Business Email',
    contactCopyEmail: 'Copy Email Address',
    contactCopied: 'Email Copied!',
    emailTemplateTitle: '💡 Please include: Institution Name · Number of Seats · Contact Phone',
    invoiceDescShort: 'Official VAT special/ordinary invoices & corporate wire transfer supported.',
    compVatSpecial: 'VAT Special Invoice',
    compVatOrdinary: 'VAT Ordinary Invoice',
    compContract: 'Standard Contract',
    compTransfer: 'Corporate Transfer',

    // Partners
    ourPartners: 'Our Partners',
    partnersSubtitle: 'Partnering with universities and educational institutions',

    // Settings Menu
    settings: 'Settings',
    userInfo: 'User Info',
    viewProfile: 'Click to view profile',
    languageSettings: 'Language Settings',
    unnamedUser: 'Unnamed User',
    user: 'User',
    logout: 'Logout',
  }
};

// 获取当前语言
export const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'zh';
};

// 设置语言
export const setLanguage = (lang) => {
  localStorage.setItem('language', lang);
  // 触发自定义事件通知语言变化
  window.dispatchEvent(new CustomEvent('languageChange', { detail: lang }));
};

// 获取翻译文本
export const t = (key, lang = null) => {
  const currentLang = lang || getCurrentLanguage();
  return translations[currentLang]?.[key] || translations['zh'][key] || key;
};

// 导出翻译对象（用于批量获取）
export const getTranslations = (lang = null) => {
  const currentLang = lang || getCurrentLanguage();
  return translations[currentLang] || translations['zh'];
};

export default {
  getCurrentLanguage,
  setLanguage,
  t,
  getTranslations,
};

